import {DOCUMENT} from '@angular/common';
import {Inject, Injectable, Optional} from '@angular/core';
import {TEXT_BASE_LANGAUGE, TEXT_LANGAUGE} from '../tokens';


const _SUFFIX = /_[a-z]+$/;

@Injectable({
	providedIn: 'root'
})
export class TextService {
	private static _self: TextService;

	language: string;
	baseLanguage: string;

	protected static _getInstance() {
		const instance = TextService._self;

		if (instance) {
			return instance;
		}

		throw new Error(`
			Does not Constructed TextService,
			Inject TextModule to AppModule or AppShellModule
		`);
	}

	static getLanguage() {
		return TextService._getInstance()
			.language;
	}

	get suffix() {
		const {language} = this;
		return language === 'kr' ? '' : '_' + language;
	}

	constructor(
		@Optional() @Inject(TEXT_LANGAUGE) language: string,
		@Optional() @Inject(TEXT_BASE_LANGAUGE) baseLanguage: string,
		@Inject(DOCUMENT) document: Document
	) {

		TextService._self = this;

		const {documentElement} = document;

		const force = location.search.match(/lang=([^&#]+)/);
		if (force) {
			language = force[1];
			documentElement.setAttribute('lang', language);
		} else if (!language) {
			language = documentElement.getAttribute('lang') || 'en';
		}
		if (!baseLanguage) {
			baseLanguage = 'en';
		}

		if (language === 'kr') {
			console.warn(`The 'lang' attribute value for Korean is 'ko'`);
		} else {
			if (language === 'ko') {
				language = 'kr';
			}
		}

		this.language = language;
		this.baseLanguage = baseLanguage;
	}

	get(values: Record<string, string>): string {
		let value = values[this.language];
		if (!value) {
			value = values[this.baseLanguage];
		}
		return value;
	}

	selectName(target: string){
		const {language} = this;
		return language === 'kr' ? target : target + '_' + language;
	}

	/**
	 * Select Translation-able property by suffix
	 * @param target
	 * @param property
	 */
	select<T extends {}>(target: T | string, property?: keyof T | string) {
		const {language} = this;

		if (!target) {
			return 'Text::Empty';
		}

		if (typeof target === 'string') {
			return target;
		}

		let firstTarget: string;
		let secondTarget: string;

		if (property) {
			if (language === 'kr') {
				firstTarget = target[property as string];
				secondTarget = target[(property as string) + '_en'];
			} else {
				firstTarget = target[(property as string) + '_' + language];
				secondTarget = target[property as string];
			}
		} else {
			firstTarget = target[language];
			secondTarget = target[this.baseLanguage];
		}

		return firstTarget || secondTarget || 'Unknown';
	}

	addSuffix(target: string) {
		return this.removeSuffix(target) + this.suffix;
	}

	removeSuffix(target: string) {
		return target.replace(_SUFFIX, '');
	}
}
